export default __webpack_public_path__ + "static/media/arrowRightLavander.ba6e571a.svg";